import {ICompetition} from '@components/competitions/ICompetitions';
import {createContext, useContext} from 'react';

type ContextType = {
	competition: ICompetition;
	mission: number;
	setMission: (_value: number) => void;
	phone: string;
	setPhone: (_value: string) => void;
};

const CompetitionAhdContext = createContext<ContextType>({
	competition: {} as ICompetition,
	mission: 0,
	setMission: (_value: number) => {
	},
	phone: '09',
	setPhone: (_value: string) => {
	}
});

const useCompetitionAhdContext = () => useContext(CompetitionAhdContext);

export {
	CompetitionAhdContext,
	useCompetitionAhdContext
};
